// extracted by mini-css-extract-plugin
export default {"inputWrapper":"EmailInput_inputWrapper__-DDpO","label":"EmailInput_label__84IKM","error":"EmailInput_error__9lsyc","input":"EmailInput_input__9m27n"};